/**
 * Create the screen reader text element
 *
 * @param {String} id        The id for the containing element.
 * @param {String} innerText The text to display to screen readers.
 *
 * @return {HTMLElement}
 */
export default function createScreenReaderText(id, innerText) {
  const span = document.createElement('span');
  span.classList.add('screen-reader-text');
  Object.assign(span, { id, innerText });

  return span;
}
